<template>
  <el-dialog
    :visible="visible"
    title="提示"
    width="1200"
    @open="getTableData"
    @close="close"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
  >
    <template #title
      ><i class="el-icon-warning text-warning me-2"></i>用户认购记录</template
    >

    <div class="d-flex justify-content-between mb-2">
      <el-form :model="formData" :inline="true" size="mini" ref="formRef">
        <el-form-item prop="userId">
          <el-input
            v-model="formData.userId"
            class="width-150"
            @keypress.enter="getTableData"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-select
            v-model="formData.defiCoinType"
            class="width-100"
            clearable
            @clear="getTableData"
            @change="getTableData"
          >
            <el-option label="全部币种" value=""></el-option>
            <el-option
              v-for="item in coinList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="mini"
            class="ms-2"
            @click="getTableData"
            >确定</el-button
          >
        </el-form-item>
      </el-form>

      <div class="addon">
        <el-button type="primary" size="mini" @click="exportBtnClick">
          导出
        </el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      size="mini"
      highlight-current-row
      style="width: 100%"
    >
      <el-table-column
        property="userId"
        label="理财ID"
        sortable
      ></el-table-column>
      <!-- <el-table-column property="xtId" label="XT-ID" sortable></el-table-column> -->
      <el-table-column
        property="defiCoinType"
        label="产品通证"
      ></el-table-column>
      <el-table-column property="userId" label="用户ID"></el-table-column>
      <el-table-column
        property="serialNumber"
        label="订单号"
        min-width="100"
      ></el-table-column>
      <el-table-column
        property="day"
        label="锁仓期限"
        min-width="100"
      ></el-table-column>
      <el-table-column
        property="buyFinancing
"
        label="订单数量"
        min-width="120"
        sortable
      >
        <template #default="scope">
          {{ thousandSeparator(scope.row.buyFinancing) }}
        </template>
      </el-table-column>

      <el-table-column label="类型" min-width="100" sortable>
        <template #default="scope">
          <span v-if="scope.row.type === 1"> 用户认购 </span>
          <span v-if="scope.row.type === 2"> 系统认购 </span
          ><span v-if="scope.row.type === 5"> 赎回 </span>
        </template>
      </el-table-column>
      <el-table-column
        property="createTime"
        label="提交时间"
        width="180"
        sortable
      >
        <template #default="scope">
          <span>{{ dateFormat(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="当前年化" min-width="100" sortable align="right">
        <template #default="scope">
          {{ scope.row.yearChemicalRate }}%
        </template>
      </el-table-column>
      <el-table-column
        label="存入时年化"
        min-width="120"
        sortable
        align="right"
      >
        <template #default="scope">
          {{ scope.row.depositYearChemicalRate }}%
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
    <div class="flex" style="padding: 20px; background-color: #f5f7fa">
      <div style="width: 10%">合计</div>
      <div style="width: 20%" class="flex">
        <div>用户认购人数&nbsp;&nbsp;</div>
        <div>
          <div v-for="o in aggList.userCount" :key="o.coin">
            {{ o.coin }} <span>{{ o.count }}人</span>
          </div>
        </div>
      </div>
      <div style="width: 20%" class="flex">
        <div>用户认购数量&nbsp;&nbsp;</div>
        <div>
          <div v-for="o in aggList.userFinancing" :key="o.coin">
            {{ o.coin }} <span>{{ o.count }}</span>
          </div>
        </div>
      </div>
      <div style="width: 20%" class="flex">
        <div>系统认购数量&nbsp;&nbsp;</div>
        <div>
          <div v-for="o in aggList.adminFinancing" :key="o.coin">
            {{ o.coin }} <span>{{ o.count }}</span>
          </div>
        </div>
      </div>
      <div style="width: 20%" class="flex">
        <div>赎回数量&nbsp;&nbsp;</div>
        <div>
          <div v-for="o in aggList.redeemFinancing" :key="o.coin">
            {{ o.coin }} <span>{{ o.count }}</span>
          </div>
        </div>
      </div>
      <div style="width: 20%" class="flex">
        <div>产品认购总量&nbsp;&nbsp;</div>
        <div>
          <div v-for="o in aggList.allFinancing" :key="o.coin">
            {{ o.coin }} <span>{{ o.count }}</span>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import Pagination from 'components/pagination'
import { thousandSeparator, dateFormat } from '@/utils/encrypt.js'

export default {
  inheritAttrs: false,
  components: { Pagination },
  props: ['visible', 'currentId'],
  data() {
    return {
      totalCount: 10,
      tableData: [],
      aggList: {
        userCount: [],
        userFinancing: [],
        adminFinancing: [],
        allFinancing: [],
        redeemFinancing: [],
      },
      formData: {
        userId: '',
        defiCoinType: '',
        id: '',
      },
      pagination: {
        page: 1,
        size: 10,
      },
    }
  },
  computed: {
    ...mapState('financial', ['coinList']),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    ...{ thousandSeparator, dateFormat },

    ...mapActions('financial', [
      'getStakingOrderList',
      'getStakingOrderAgg',
      'getStakingExportOrder',
    ]),
    pageChanged(pagination) {
      this.pagination = pagination
      this.getTableData()
    },
    open() {
      this.getTableData()
    },
    close() {
      this.$refs['formRef'].resetFields()

      this.$emit('update:visible', false)
    },

    getTableData() {
      this.formData.id = this.currentId

      const params = {
        ...this.pagination,
        ...this.formData,
      }
      this.getStakingOrderAgg(this.formData).then((res) => {
        const aggListTemp = {
          userCount: [],
          userFinancing: [],
          adminFinancing: [],
          allFinancing: [],
          redeemFinancing: [],
        }
        res.data.forEach((item) => {
          aggListTemp.userCount.push({
            count: item.userCont,
            coin: item.defiCoinType,
          })
          aggListTemp.userFinancing.push({
            count: item.userFinancing,
            coin: item.defiCoinType,
          })
          aggListTemp.adminFinancing.push({
            count: item.adminFinancing,
            coin: item.defiCoinType,
          })
          aggListTemp.allFinancing.push({
            count: item.allFinancing,
            coin: item.defiCoinType,
          })
          aggListTemp.redeemFinancing.push({
            count: item.redeemFinancing,
            coin: item.defiCoinType,
          })
        })
        this.aggList = aggListTemp
      })
      this.getStakingOrderList(params).then((res) => {
        this.tableData = res.data.data
        this.totalCount = res.data.total
      })
    },
    handelConfirm() {
      this.$refs['formRef'].validate((valid) => {
        if (!valid) return

        this.close()
      })
    },
    exportBtnClick() {
      const params = {
        coinType: 'USDT',
        productStatus: '',
        time: '1681487999000',
      }
      this.getStakingExportOrder(params)
    },
  },
}
</script>
<style>
.flex {
  display: flex;
}
</style>
